import type { Placement } from '@popperjs/core';
import React, { useState } from 'react';
import ContentPreviewPopOver from '../components/ContentPreviewPopOver';
import { useIsSize } from '../utils/responsive/isSize';
import Sizes from '../utils/responsive/Sizes';
import UserDetailPreview from './UserDetailPreview';

interface UserDetailPreviewPopOverProps {
  userId: string;
  children: React.ReactNode;
  display?: 'block' | 'inline-block' | 'inline';
  allowFlip?: boolean;
  placement?: Placement;
  longHoverDelay?: boolean;
}

const UserDetailPreviewPopOver = ({
  userId,
  children,
  display,
  allowFlip,
  placement,
  longHoverDelay,
}: UserDetailPreviewPopOverProps) => {
  const [minHeight, setMinHeight] = useState<number | null>(null);

  const isPreviewLoaded = minHeight !== null;

  const isMobile = useIsSize(Sizes.SM);

  if (isMobile) {
    return <>{children}</>;
  }

  return (
    <ContentPreviewPopOver
      display={display}
      hidden={!isPreviewLoaded}
      allowFlip={allowFlip}
      minWidth={250}
      minHeight={100}
      popOver={
        <UserDetailPreview userId={userId} setMinHeight={setMinHeight} />
      }
      placement={placement}
      longHoverDelay={longHoverDelay}
    >
      {children}
    </ContentPreviewPopOver>
  );
};

export default UserDetailPreviewPopOver;
